import {getMonth, getYear, isSameMonth, isSameYear} from 'date-fns';
import {combine, merge, sample} from 'effector';
import {createGate} from 'effector-react';

import {showRestError} from '@app/errors';
import {rootDomain} from '@app/model';
import {dateModel} from '@entities/date/model';

import * as api from './api';
import {ManagementSummary} from './types';

const domain = rootDomain.createDomain('ManagementSummary');

export const ManagementSummaryGate = createGate('ManagementSummary');

const fetchDataFx = domain.createEffect({handler: api.fetch});
fetchDataFx.failData.watch(showRestError);

const data$ = domain
    .createStore<ManagementSummary | null>(null)
    .on(fetchDataFx.doneData, (_, data) => data)
    .reset(ManagementSummaryGate.close);

sample({
    clock: merge([ManagementSummaryGate.open, dateModel.changed]),
    source: dateModel.state,
    filter: ManagementSummaryGate.status,
    fn: ({range}) => {
        const from = range.from ?? new Date();
        const to = range.to ?? from;
        const hasSingleMonth = isSameYear(from, to) && isSameMonth(from, to);

        return {
            year: getYear(from),
            month: hasSingleMonth ? getMonth(from) + 1 : null,
        };
    },
    target: fetchDataFx,
});

const $managementSummaryState = combine({
    data: data$,
    pending: fetchDataFx.pending,
});

export const managementSummaryModel = {
    state: $managementSummaryState,
};
